import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ServerConstantsService } from './server-constants.service';
import { ActivatedRoute, Router } from '@angular/router';

@Injectable()
export class DataService {
  ServerConstants: any;
  globalAccess: Boolean;
  isWorker:Boolean;
  isLDAP:Boolean;
  allPageKeys = [];
  sharedDataMap = new Map<string, any>();
  clientPages = ['APPTS',
    'ASMNT',
    'CLINF',
    'CNHIS',
    'COMPS',
    'CSNTS',
    'EMPPL',
    'NCMPL',
    'RIMBS'];

  constructor(
    private http: HttpClient,
    private serverConstantsService: ServerConstantsService,
    private router: Router
  ) {
    this.ServerConstants = serverConstantsService.getConstants();
    this.loadPageRolesData();
  }

  async loadPageRolesData() {

    this.loaduserInfoData();
    await this.http.get<any>(this.ServerConstants.SERVER_API_URL + '/pages').subscribe(
      data => {
        const allAccessObjects = new Map<string, any>();
        for (const key in data) {
          if (data.hasOwnProperty(key)) {
            const pageObject = data[key];
            sessionStorage.setItem(key, JSON.stringify(pageObject));
            this.addValueToSharedDataMap(key, pageObject);
            const pageObjCopy = JSON.parse(JSON.stringify(pageObject));
            allAccessObjects.set(key, pageObjCopy);
          }
        }
        this.addValueToSharedDataMap('ALL_PAGE_ACCESS_INFO', allAccessObjects);
        this.allPageKeys = Object.keys(data);
        console.log('shared data upon login', this.sharedDataMap);
      }, response => {
        console.log('Get call in error', response);
      }, () => {

      });

  }



  loaduserInfoData() {

    this.http.get<any>(this.ServerConstants.SERVER_API_URL + '/userinfo').subscribe(
      data => {
        for (const key in data) {
          if (data.hasOwnProperty(key)) {
            console.log(key + ': ' + JSON.stringify(data[key]));
            this.addValueToSharedDataMap(key, data[key])
          }
        }
        console.log('data', data);
      }, response => {
        console.log('Get call in error', response);
        if(response.status === 401){
          this.router.navigate(['SNAPWorks/providerportal']);
        }
      }, () => {

      });

  }
  getSharedDataObject() {
    return this.sharedDataMap;
  }

  addValueToSharedDataMap(key, value) {
    this.sharedDataMap.set(key, value);
  }

  removeValueFromSharedDataMap(key) {
    if (this.sharedDataMap.has(key)) {
      this.sharedDataMap.delete(key);
    }
  }

  isComponentDisable(componentKey: string): boolean {
    return this.sharedDataMap.get(componentKey).readOnly;
  }


  makeAllPagesReadyIfCaseClosed() {

    console.log(" makeAllPagesReadyIfCaseClosed ==== START");

    this.clientPages.forEach(page => {
      if (this.sharedDataMap.get(page) !== undefined) {

        const pageObject = JSON.parse(JSON.stringify(this.sharedDataMap.get(page)));

        if(page !== 'RIMBS') {
          pageObject.readOnly = true;
          if (pageObject.innerNavPages !== undefined && pageObject.innerNavPages.length > 0) {
            pageObject.innerNavPages.forEach(innerPage => {
              innerPage.readOnly = true;
            });
          }
        }
        
        this.addValueToSharedDataMap(page, pageObject);
      }
    }

    );
    this.addValueToSharedDataMap('IS_CASE_CLOSE_READ_ONLY', true);
    console.log(" makeAllPagesReadyIfCaseClosed ==== END");
  }

  revertReadOnlyChanges() {
    const isCaseClosed = this.sharedDataMap.get('IS_CASE_CLOSE_READ_ONLY');
    const allAccessObjects = this.sharedDataMap.get('ALL_PAGE_ACCESS_INFO');
    if (isCaseClosed !== undefined && isCaseClosed) {
      this.clientPages.forEach(page => {
        if (allAccessObjects.get(page) !== undefined) {
          this.addValueToSharedDataMap(page, allAccessObjects.get(page));
        }
      });
    }
  }

  allPagesReadOnly() {
    this.allPageKeys.forEach(page => {
      if (this.sharedDataMap.get(page) !== undefined) {
        const pageObject = JSON.parse(JSON.stringify(this.sharedDataMap.get(page)));
        pageObject.readOnly = true;
        if (pageObject.innerNavPages !== undefined && pageObject.innerNavPages.length > 0) {
          pageObject.innerNavPages.forEach(innerPage => {
            innerPage.readOnly = true;
          });
        }
        this.addValueToSharedDataMap(page, pageObject);
      }
    });
    this.addValueToSharedDataMap('IS_ALL_PAGES_READ_ONLY', true);
  }

  revertAllPagesReadOnly() {
    const isAllPagesReadOnly = this.sharedDataMap.get('IS_ALL_PAGES_READ_ONLY');
    const allAccessObjects = this.sharedDataMap.get('ALL_PAGE_ACCESS_INFO');
    if (isAllPagesReadOnly !== undefined && isAllPagesReadOnly) {
      this.allPageKeys.forEach(page => {
        if (allAccessObjects.get(page) !== undefined) {
          this.addValueToSharedDataMap(page, allAccessObjects.get(page));
        }
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/Data.service.ts